import { getPageAllowedRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { warehouseApplicationPageActions } from "./warehouseApplicationPageActions";
import { WriteOnlyNotice } from "../warehouseSettings/WriteOnlyNotice";
import { warehouseApplicationPageConfig } from "./warehouseApplicationPageConfig";
import {
  newWarehouseApplication,
  readWarehouseApplication,
  toWarehouseApplicationPayload,
  warehouseApplicationValidators,
} from "./warehouseApplicationRecord";

export const warehouseApplicationRecordDefinition: RecordDefinition = {
  path: "/warehouse-application",
  actions: warehouseApplicationPageActions,
  // The label the Warehouse API keeps an application's audits under.
  entityName: "WarehouseApplication",
  listRoute: "/warehouse-applications",
  backTitle: "Back to warehouse applications",
  allowedRoles: getPageAllowedRoles("warehouse-application"),
  config: warehouseApplicationPageConfig,
  // Kept in Warehouse configuration, which has no views to design.
  authorable: false,
  readRecord: readWarehouseApplication,
  newRecord: newWarehouseApplication,
  toSavePayload: toWarehouseApplicationPayload,
  identity: {
    titleFields: ["ClientId"],
    fallbackTitle: "Warehouse Application",
    newRecordTitle: "New Application",
  },
  fieldComponents: { warehouseWriteOnlyNotice: WriteOnlyNotice },
  fieldValidators: warehouseApplicationValidators,
  visibilityRules: {
    warehouseApplicationIsNew: (record) => !record.id,
    warehouseApplicationSecretSet: (record) =>
      Boolean(record.id) && Boolean(record.HasClientSecret),
    warehouseApplicationSecretNotSet: (record) =>
      Boolean(record.id) && !record.HasClientSecret,
  },
};
